import {
  UseQueryOptions,
  UseQueryResult,
  useQueries,
  useQuery,
} from 'react-query';

import { requestStardogVoiceboxDescription } from 'bones/utils/voicebox/request';

const requestPortalVoiceboxDescription =
  (connectionId: string, databaseId: string, model: string) => async () => {
    if (!connectionId || !databaseId || !model) {
      return null;
    }

    const response = await requestStardogVoiceboxDescription({
      connectionId,
      databaseId,
      model,
    });

    if (response.error) {
      throw new Error(response.error);
    }

    return {
      databaseId,
      model,
      description: response.result || '',
    };
  };

export const usePortalVoiceboxDescription = (
  connectionId: string,
  connectionIdx: number,
  databaseId: string,
  model: string,
  options?: UseQueryOptions<{
    databaseId: string;
    model: string;
    description: string;
  } | null>
): UseQueryResult<{
  databaseId: string;
  model: string;
  description: string;
} | null> => {
  return useQuery<{
    databaseId: string;
    model: string;
    description: string;
  } | null>(
    `usePortalVoiceboxDescription-${
      connectionId ? connectionIdx : null
    }-${databaseId}-${model}`,
    requestPortalVoiceboxDescription(connectionId, databaseId, model),
    options
  );
};

export const usePortalVoiceboxDescriptions = (
  connectionId: string,
  connectionIdx: number,
  databaseModels: Array<[string, string]>,
  options?: (
    ...args: Parameters<typeof requestPortalVoiceboxDescription>
  ) => UseQueryOptions<{
    databaseId: string;
    model: string;
    description: string;
  } | null>
): Array<
  UseQueryResult<{
    databaseId: string;
    model: string;
    description: string;
  } | null>
> => {
  return useQueries(
    databaseModels.map(
      ([databaseId, model]): UseQueryOptions<{
        databaseId: string;
        model: string;
        description: string;
      } | null> => ({
        queryKey: `usePortalVoiceboxDescription-${
          connectionId ? connectionIdx : null
        }-${databaseId}-${model}`,
        queryFn: requestPortalVoiceboxDescription(
          connectionId,
          databaseId,
          model
        ),
        ...(options?.(connectionId, databaseId, model) || {}),
      })
    )
  );
};
